import { render } from "./ProyectorView.vue?vue&type=template&id=5719d772&scoped=true"
import script from "./ProyectorView.vue?vue&type=script&lang=js"
export * from "./ProyectorView.vue?vue&type=script&lang=js"

import "./ProyectorView.vue?vue&type=style&index=0&id=5719d772&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5719d772"]])

export default __exports__